import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const Settings = () => {


    return (
        <>

            <style>
                {
                    `.mylink:hover{
                    background:#e4f1ff;
               }`
                }
               
            </style>

            <div className='dropdown'>
                <button
                    className='has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center'
                    type='button'
                    data-bs-toggle='dropdown'
                >
                    <Icon
                        icon='ant-design:setting-twotone'
                        className='text-xl'
                    />
                </button>
                <div className='dropdown-menu to-top dropdown-menu-lg p-0'>
                    <div className='m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                        <div>
                            <h6 className='text-lg text-primary-light fw-semibold mb-0'>
                                Settings
                            </h6>
                        </div>
                    </div>
                    <div className='max-h-400-px overflow-y-auto scroll-sm pb-3'>
                        <Link
                            to='/center-group'
                            className='mylink px-24 py-10 d-flex align-items-start mb-1 justify-content-between'
                        >
                            <div className='d-flex align-items-center gap-3'>
                                <div className="w-25-px h-25-px d-flex align-items-center">
                                    <Icon
                                        icon='teenyicons:home-outline'
                                        className='text-xl'
                                    />
                                </div>
                                <div>
                                    <p className='text-lg fw-bold mb-0'>
                                        Center Groups
                                    </p>

                                </div>
                            </div>

                        </Link>
                        <Link
                            to='/change-password'
                            className='mylink px-24 py-10 d-flex align-items-start mb-1 justify-content-between'
                        >
                            <div className='d-flex align-items-center gap-3'>
                                <div className="w-25-px h-25-px d-flex align-items-center">
                                    <Icon
                                        icon='teenyicons:password-outline'
                                        className='text-xl'
                                    />
                                </div>
                                <div>
                                    <p className='text-lg fw-bold mb-0'>
                                        Change Password
                                    </p>

                                </div>
                            </div>

                        </Link>
                       

                    </div>
                </div>
            </div>
        </>

    );
};

export default Settings;

